import { WhitelabelSettingReadModel } from "../../../@api";

import { ExternalLinkKeys } from "../../stores";
import { IStoreContext } from "../../stores/StoreContext";
import { appSettingsKeys } from "../app-setting-keys";
import { translationKeys } from "../app-translation-keys";
import { applyCSSSetting } from "./apply-css-setting.function";
import { findWhitelabelSetting as findWLSetting } from "./find-whitelabel-setting.function";

export const applyWhitelabelSettings = async (settings: WhitelabelSettingReadModel[], storeContext: IStoreContext) => {
  // Apply store settings
  applyStoreSettings(settings, storeContext);

  // Apply CSS settings
  applyCSSSettings(settings);
};

const applyStoreSettings = async (settings: WhitelabelSettingReadModel[], storeContext: IStoreContext) => {
  const appKeys = appSettingsKeys;

  storeContext.navigationStore.externalNavigationLinks = [
    {
      key: ExternalLinkKeys.Contact,
      labelKey: translationKeys.footer.contact,
      url: findWLSetting(settings, appKeys["General.Link.ContactLinkDE"])?.customValue,
    },
    {
      key: ExternalLinkKeys.PrivacyPolicity,
      labelKey: translationKeys.footer.privacyPolicy,
      url: findWLSetting(settings, appKeys["General.Link.PrivacyPolicyLinkDE"])?.customValue,
    },
    {
      key: ExternalLinkKeys.Impressum,
      labelKey: translationKeys.footer.impressum,
      url: findWLSetting(settings, appKeys["General.Link.ImpressumLinkDE"])?.customValue,
    },
  ];

  storeContext.whitelabelStore.chatBotName =
    findWLSetting(settings, appKeys["General.ChatBotName"])?.customValue ?? "smartChat";
};

const applyCSSSettings = (settings: WhitelabelSettingReadModel[]) => {
  const appKeys = appSettingsKeys;

  // PrimeNG overrides
  applyCSSSetting("", "text-color", findWLSetting(settings, appKeys["Color.TextColor"])?.customValue);

  // Colors
  applyCSSSetting("customer-", "text-color", findWLSetting(settings, appKeys["Color.TextColor"])?.customValue);
  applyCSSSetting("customer-", "link-color", findWLSetting(settings, appKeys["Color.LinkColor"])?.customValue);
  applyCSSSetting(
    "customer-",
    "brand-color-background",
    findWLSetting(settings, appKeys["Color.BrandColorBackground"])?.customValue,
  );
  applyCSSSetting(
    "customer-",
    "brand-color-foreground",
    findWLSetting(settings, appKeys["Color.BrandColorForeground"])?.customValue,
  );
  applyCSSSetting(
    "customer-",
    "button-color-background",
    findWLSetting(settings, appKeys["Color.ButtonColorBackground"])?.customValue,
  );
  applyCSSSetting(
    "customer-",
    "button-color-foreground",
    findWLSetting(settings, appKeys["Color.ButtonColorForeground"])?.customValue,
  );

  applyCSSSetting(
    "customer-",
    "button-primary-gradient-background",
    findWLSetting(settings, appKeys["Color.ButtonGradientColorBackground"])?.customValue,
  );
  applyCSSSetting(
    "customer-",
    "button-primary-gradient-background-hover",
    findWLSetting(settings, appKeys["Color.ButtonGradientColorBackgroundHover"])?.customValue,
  );
  applyCSSSetting(
    "customer-",
    "button-primary-gradient-foreground",
    findWLSetting(settings, appKeys["Color.ButtonGradientColorForeground"])?.customValue,
  );

  // Borders
  applyCSSSetting(
    "customer-",
    "border-radius",
    findWLSetting(settings, appKeys["Layout.Border.HasRoundedBorder"])?.customValue?.toString() === "true"
      ? undefined
      : 0,
  );
  applyCSSSetting(
    "customer-",
    "border-radius-small",
    findWLSetting(settings, appKeys["Layout.Border.HasRoundedBorder"])?.customValue?.toString() === "true"
      ? undefined
      : 0,
  );

  // Font Family
  applyCSSSetting("", "font-family", findWLSetting(settings, appKeys["Font.Family"])?.customValue);
  applyCSSSetting("customer-", "font-family", findWLSetting(settings, appKeys["Font.Family"])?.customValue);

  // Other settings
  applyCSSSetting(
    "customer-",
    "header-row-direction",
    findWLSetting(settings, appKeys["Layout.Positions.IsLogoLeft"])?.customValue?.toString() === "true"
      ? "row"
      : "row-reverse",
  );
};
